import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents,
} from '@denishussar/html5-game-engine';
import { AppStateEnum, GameModel } from '../../../../Models/Game/GameModel';
import {
    ButtonCloseController,
    IButtonCloseControllerOptions,
} from './ButtonCloseController';
import { AnimationContents } from '../../../../../AnimationContents';
import {
    ButtonPageController,
    IButtonPageControllerOptions,
} from './ButtonPageController';
import { GameLogic } from '../../../../Logic/GameLogic';
import {
    ButtonArrowController,
    IButtonArrowControllerOptions,
} from './ButtonArrowController';

export interface IRulesScreenControllerOptions {}

export class RulesController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private _options: IRulesScreenControllerOptions,
        @Inject private _modelEvents: ModelEvents,
        @Inject private _gameLogic: GameLogic
    ) {
        super('RulesController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.RULES_SCREEN_JSON,
            libraryName: 'main',
            childControllers: {
                prev_page: {
                    instanceName: 'container.window.left_arrow',
                    view: ButtonArrowController,
                    model: this.$model,
                    options: <IButtonArrowControllerOptions>{
                        onClick: () => {
                            if (
                                this.$model.appState === AppStateEnum.menu ||
                                (this.$model.appState === AppStateEnum.game &&
                                    !this.$model.isFirstLaunch)
                            ) {
                                this._gameLogic.referenceScreenPrevPage();
                            }
                        },
                    },
                },
                next_page: {
                    instanceName: 'container.window.right_arrow',
                    view: ButtonArrowController,
                    model: this.$model,
                    options: <IButtonArrowControllerOptions>{
                        onClick: () => {
                            if (
                                this.$model.appState === AppStateEnum.menu ||
                                (this.$model.appState === AppStateEnum.game &&
                                    !this.$model.isFirstLaunch)
                            ) {
                                this._gameLogic.referenceScreenNextPage();
                            }
                        },
                    },
                },
                window_next_page: {
                    instanceName: 'container.window',
                    view: ButtonArrowController,
                    model: this.$model,
                    options: <IButtonArrowControllerOptions>{
                        onClick: () => {
                            if (
                                this.$model.appState === AppStateEnum.game &&
                                this.$model.isFirstLaunch
                            ) {
                                if (
                                    this.$model.referenceScreenCurrentPage === 2
                                ) {
                                    this.gotoAndPlayByQuery(
                                        'container',
                                        'window close',
                                        false,
                                        false
                                    );
                                    this.$queue.get('hide').addToQueue();
                                }
                                this._gameLogic.referenceScreenNextPage();
                            }
                        },
                    },
                },
                btn_close: {
                    instanceName: 'container.window.btn_close',
                    view: ButtonCloseController,
                    options: <IButtonCloseControllerOptions>{
                        onClick: () => {
                            if (
                                this.$model.appState === AppStateEnum.menu ||
                                (this.$model.appState === AppStateEnum.game &&
                                    !this.$model.isFirstLaunch)
                            ) {
                                this.gotoAndPlayByQuery(
                                    'container',
                                    'window close',
                                    false,
                                    false
                                );
                                this.$queue.get('hide').addToQueue();
                            }
                        },
                    },
                },
            },
            queue: {
                hide: {
                    condition: (clock: number) => clock > 0.3,
                    action: () => {
                        if (
                            this.$model.appState === AppStateEnum.game &&
                            this.$model.isFirstLaunch
                        ) {
                            this._gameLogic.resetGamePause();
                        } else if (this.$model.appState === AppStateEnum.game) {
                            this._gameLogic.showGamePause();
                        } else {
                            this._gameLogic.resetMenu();
                        }
                    },
                },
            },
            modelWatch: {
                referenceScreenCurrentPage: (
                    newValue: number,
                    oldValue: number
                ) => {
                    if (newValue === 1) {
                        this.gotoAndStopByQuery(
                            'container.window.prev_page',
                            'on page',
                            false
                        );
                        this.gotoAndStopByQuery(
                            'container.window.next_page',
                            'off page',
                            false
                        );
                    } else {
                        this.gotoAndStopByQuery(
                            'container.window.prev_page',
                            'off page',
                            false
                        );
                        this.gotoAndStopByQuery(
                            'container.window.next_page',
                            'on page',
                            false
                        );
                    }
                    this.gotoAndStopByQuery(
                        'container.window',
                        `page${this.$model.referenceScreenCurrentPage}`,
                        false
                    );
                },
            },
        };
    }

    protected onInitialize(): void {
        this.gotoAndPlayByQuery(
            'container',
            'window initialization',
            false,
            false
        );
        this.gotoAndStopByQuery('container.window', 'page1', false);
        this.gotoAndStopByQuery('container.window.prev_page', 'on page', false);
        this.gotoAndStopByQuery(
            'container.window.next_page',
            'off page',
            false
        );
    }

    protected onLandscape(): void {
        this.display.scale.set(1.3);
        this.display.y = 25;
    }
}
